import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getEnvVariables } from "../helpers/getEnvVariables";
import { ensureMetaPixelInitialized, metaTrackPageView } from "../analytics/metaConversions";

function injectGtm(containerId) {
  if (!containerId || typeof window === "undefined" || window.__CERVALLE_GTM_INITIALIZED__) return;
  window.__CERVALLE_GTM_INITIALIZED__ = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const firstScript = document.getElementsByTagName("script")[0];
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(containerId);
  firstScript.parentNode.insertBefore(script, firstScript);
}

export default function AnalyticsProvider({ children }) {
  const location = useLocation();
  const gtmId = getEnvVariables().GTM;
  const metaPixelId = getEnvVariables().META_PIXEL_ID;
  const gtmStarted = useRef(false);
  const metaPixelBooted = useRef(false);

  useEffect(() => {
    if (!gtmId || gtmStarted.current) return;
    gtmStarted.current = true;
    injectGtm(gtmId);
  }, [gtmId]);

  useEffect(() => {
    if (!metaPixelId || metaPixelBooted.current) return;
    metaPixelBooted.current = true;
    ensureMetaPixelInitialized();
  }, [metaPixelId]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.dataLayer) return;
    window.dataLayer.push({
      event: "virtual_page_view",
      page_path: location.pathname + location.search,
    });
    if (metaPixelId && window.fbq) {
      metaTrackPageView();
    }
  }, [location, metaPixelId]);

  return children;
}
